import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import TimeLimit from "../../../types/TimeLimit"


export interface componentProps {
    item: TimeLimit
}

const ItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.info')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('time-limits.form.is_dynamic')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.isDynamic ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('time-limits.form.start_date')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.startDate || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('time-limits.form.end_date')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.endDate || '-'}</IonNote>
            </IonItem>
            {item.externalId &&
                <IonItem lines="full">
                    <IonLabel position="fixed">{t('common.external_id')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{item.externalId || '-'}</IonNote>
                </IonItem>
            }
            {item.meta?.syncedAt &&
                <IonItem lines="full">
                    <IonLabel>{t('common.synced_at')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{item.meta.syncedAt || '-'}</IonNote>
                </IonItem>
            }
        </IonItemGroup>
    )
}

export default ItemGroupInfo